import { ButtonPrimary, ButtonText } from 'components/Button'
import { AutoColumn } from 'components/Column'
import { SwapPoolTabs } from 'components/NavigationTabs'
import { Activity } from 'react-feather'
import { UnsupportedChainIdError, useWeb3React } from 'packages/core'
import { ButtonSecondary } from '../../components/Button'
import TransactionConfirmationModal, { ConfirmationModalContent } from "../../components/TransactionConfirmationModal";
import { TransactionResponse } from "@ethersproject/providers";
import { darken } from 'polished'
import { useContext, useState, useCallback, useMemo } from 'react'
import { useWalletModalToggle } from 'state/application/hooks'
import { useUserHideClosedPositions } from 'state/user/hooks'
import useRewardStorage from 'hooks/useRewardStorage'
import { useRewardStorageContract } from 'hooks/useContract'
import useDDJ from 'hooks/useDDJ'
import styled, { ThemeContext } from 'styled-components/macro'
import { ThemedText } from 'theme'
import { ethers } from 'ethers'
import { TransactionType } from 'state/transactions/actions'
import { useTransactionAdder } from "state/transactions/hooks";

const PageWrapper = styled(AutoColumn)`
  max-width: 870px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    max-width: 800px;
  `};

  ${({ theme }) => theme.mediaWidth.upToSmall`
    max-width: 500px;
    width:100%;
  `};
`

const NoLiquidity = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: auto;  
    width:416px;
    ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 300px;
    `};
`

const MainContentWrapper = styled.main`
  background-color: ${({ theme }) => theme.bg0};
  display: flex;
  flex-direction: column;
`
const Web3StatusGeneric = styled(ButtonSecondary)`
  ${({ theme }) => theme.flexRowNoWrap}
  width: 100%;
  align-items: center;
  padding: 0.5rem;
  border-radius: 100px;
  cursor: pointer;
  user-select: none;
  height: 36px;
  margin-right: 0px;
  margin-left: 0px;
  :focus {
    outline: none;
  }
`

const Web3StatusError = styled(Web3StatusGeneric)`
  background-color: ${({ theme }) => theme.red1};
  border: none;
  color: ${({ theme }) => theme.white};
  font-weight: 600;
  margin-top: 2em;
  height: 40px;
  :hover,
  :focus {
    background-color: ${({ theme }) => darken(0.1, theme.red1)};
  }
`

const NetworkIcon = styled(Activity)`
  margin-left: 0.25rem;
  margin-right: 0.5rem;
  width: 16px;
  height: 16px;
`

const Text = styled.p`
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0 0.5rem 0 0.25rem;
  font-size: 1rem;
  width: fit-content;
  font-weight: 600;
  
`

export default function Claim() {
  const { account, error } = useWeb3React()
  const toggleWalletModal = useWalletModalToggle()
  const { threshold, reward } = useRewardStorage()
  const { balance } = useDDJ()
  const rewardStorageContract = useRewardStorageContract(true)
  const addTransaction = useTransactionAdder()

  const [loading, setLoading] = useState<boolean>(false)
  const [showConfirm, setShowConfirm] = useState<boolean>(false)
  const [attemptingTxn, setAttemptingTxn] = useState<boolean>(false) // clicked confirm
  const [txHash, setTxHash] = useState<string>('')

  const isEnough = useMemo(() => {
    return reward.gte(threshold)
  }, [reward, threshold])

  // @ts-ignore
  const theme = useContext(ThemeContext)
  const [userHideClosedPositions, setUserHideClosedPositions] = useUserHideClosedPositions()
  const showConnectAWallet = Boolean(!account)
  const pendingText = "Pending Confirmation";

  const onWithdraw = async () => {
    if (isEnough && rewardStorageContract) {
      try {
        setLoading(true)

        const response: TransactionResponse = await rewardStorageContract.withdrawRewards()
        addTransaction(response, {
          type: TransactionType.WITHDRAW_REWARD
        })
        setTxHash(response.hash)
        setShowConfirm(true);
        await response.wait()

      } catch (error) {
        console.error('Failed to send transaction', error)
        // we only care if the error is something _other_ than the user rejected the tx
        if (error?.code !== 4001) {
          console.error(error)
        }
      } finally {
        setLoading(false)
        setAttemptingTxn(false)
      }
    }
  }

  const formatedReward = useMemo(() => {
    const value = parseFloat(ethers.utils.formatUnits(reward, 36))
    return value === 0 ? 0 : value.toFixed(6);
  }, [reward])

  const formatedBalance = useMemo(() => {
    const value = parseFloat(ethers.utils.formatEther(balance))
    return value === 0 ? 0 : value.toFixed(6);
  }, [balance])

  const handleDismissConfirmation = useCallback(() => {
    setShowConfirm(false)
    // if there was a tx hash, we want to clear the input
    if (txHash) {
      setTxHash('')
    }
  }, [txHash])

  return (
    <>
      <TransactionConfirmationModal
        isOpen={showConfirm}
        onDismiss={handleDismissConfirmation}
        attemptingTxn={attemptingTxn}
        hash={txHash}
        content={() => (
          <ConfirmationModalContent
            title={""}
            onDismiss={handleDismissConfirmation}
            bottomContent={() => (
              <button className='view-etherscan'>
                <p>
                  View on Block Explorer
                </p>
              </button>
            )}
          />
        )}
        pendingText={pendingText}
      />

      <PageWrapper>
        <AutoColumn gap="lg" justify="center">
          <AutoColumn gap="lg" style={{ width: '100%', justifyContent: "center", paddingTop: "56px" }}>

            <SwapPoolTabs active={'pool'} />
            <AutoColumn gap="lg" justify="center">
              <AutoColumn gap="lg" style={{ justifyContent: "center" }}>
              <div style={{background:  "linear-gradient(73.6deg, #85FFC4 2.11%, #5CC6FF 42.39%, #BC85FF 85.72%)", padding:'1px',borderRadius:'40px' }}>
                  <MainContentWrapper className='pool-body-NoLiquidity' style={{ background: "#16161F", maxWidth: '512px', minHeight: "586px", borderRadius: '40px', padding: '32px' }}  >
                    {
                      showConnectAWallet
                        ?
                        <NoLiquidity>
                          <ThemedText.Body color={theme.text3} textAlign="center">
                            <svg width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: "flex" }}>
                              <path d="M68.75 37.5H50L43.75 46.875H31.25L25 37.5H6.25" stroke="url(#paint0_linear_3832_13200)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M17.0313 15.9688L6.25 37.5V56.25C6.25 57.9076 6.90848 59.4973 8.08058 60.6694C9.25269 61.8415 10.8424 62.5 12.5 62.5H62.5C64.1576 62.5 65.7473 61.8415 66.9194 60.6694C68.0915 59.4973 68.75 57.9076 68.75 56.25V37.5L57.9688 15.9688C57.4513 14.9275 56.6537 14.0512 55.6655 13.4384C54.6773 12.8256 53.5378 12.5006 52.375 12.5H22.625C21.4622 12.5006 20.3227 12.8256 19.3345 13.4384C18.3463 14.0512 17.5487 14.9275 17.0313 15.9688V15.9688Z" stroke="url(#paint1_linear_3832_13200)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                              <defs>
                                <linearGradient id="paint0_linear_3832_13200" x1="7.95454" y1="46.875" x2="24.2825" y2="14.8373" gradientUnits="userSpaceOnUse">
                                  <stop stopColor="#85FFC4" />
                                  <stop offset="0.411458" stopColor="#5CC6FF" />
                                  <stop offset="0.854167" stopColor="#BC85FF" />
                                </linearGradient>
                                <linearGradient id="paint1_linear_3832_13200" x1="7.95454" y1="62.5" x2="77.7043" y2="36.8389" gradientUnits="userSpaceOnUse">
                                  <stop stopColor="#85FFC4" />
                                  <stop offset="0.411458" stopColor="#5CC6FF" />
                                  <stop offset="0.854167" stopColor="#BC85FF" />
                                </linearGradient>
                              </defs>
                            </svg>

                            <img style={{ width: "250px", height: "175px", display: "none" }} src="images/1.svg" alt={"1"} />
                          </ThemedText.Body>

                          <ButtonText
                            style={{ marginTop: '.5rem', color: "white", fontSize: "14px" }}
                            onClick={() => setUserHideClosedPositions(!userHideClosedPositions)}
                          >
                            Your positions will appear here
                          </ButtonText>
                          {
                            error instanceof UnsupportedChainIdError ?
                              <Web3StatusError onClick={toggleWalletModal}>
                                <NetworkIcon />
                                <Text>{error instanceof UnsupportedChainIdError ? <>Wrong Network</> : Error}</Text>
                              </Web3StatusError>
                              : showConnectAWallet && (

                                <ButtonPrimary style={{ marginTop: '2em', padding: '8px 16px', width: "100%", height: "40px" }} className="pool-body-connect" onClick={toggleWalletModal}>
                                  Connect Wallet
                                </ButtonPrimary>
                              )
                          }
                        </NoLiquidity>
                        :
                        <NoLiquidity>
                          <ThemedText.LargeHeader style={{ color: "white", fontWeight: '600', marginBottom: '24px', fontSize: '24px', lineHeight: '28px' }}>
                            Rewards
                          </ThemedText.LargeHeader>
                          <ThemedText.Body style={{ color: 'white', fontWeight: 700, fontSize: 32, lineHeight: '42px', textAlign: 'center' }}>
                            {formatedReward}
                          </ThemedText.Body>
                          <ThemedText.Body
                            color={'#8F96AC'}
                            fontWeight={400}
                            fontSize={16}
                            style={{ cursor: 'auto', opacity: 1, textAlign: 'center', lineHeight: '24px', marginBottom: '32px' }}
                          >
                            Withdraw Threshold: {parseInt(ethers.utils.formatUnits(threshold, 36))}
                          </ThemedText.Body>
                          <button className='primary-button' disabled={!isEnough || loading} style={{ marginBottom: '24px' }} onClick={onWithdraw}>
                            <p style={{ color: "white" }}>
                              {
                                isEnough ? 'Withdraw' : 'Not enough rewards to withdraw'
                              }
                            </p>
                          </button>
                          <ThemedText.LargeHeader style={{ color: "white", fontWeight: '700', marginBottom: '5px', fontSize: '24px', lineHeight: '42px' }}>
                            DDJ Balance
                          </ThemedText.LargeHeader>
                          <ThemedText.Body style={{ color: 'white', textAlign: 'center', fontSize: 20, lineHeight: '42px', fontWeight: 700 }}>
                            {formatedBalance}
                          </ThemedText.Body>
                        </NoLiquidity>
                    }
                  </MainContentWrapper>
                </div>
              </AutoColumn>
            </AutoColumn>
          </AutoColumn>
        </AutoColumn>
      </PageWrapper>
    </>
  )
}
